import React, { useEffect, useRef } from 'react';
import './CancelRecurringMembershipModal.css';

function CancelRecurringMembershipModal({ 
  isOpen, 
  membership, 
  onConfirm, 
  onCancel 
}) {
  const modalRef = useRef(null);

  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape') {
        onCancel();
      }
    };

    if (isOpen) {
      document.addEventListener('keydown', handleEscape);
      document.body.style.overflow = 'hidden';
    }

    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = 'unset';
    };
  }, [isOpen, onCancel]);

  useEffect(() => {
    if (isOpen && modalRef.current) {
      modalRef.current.focus();
    }
  }, [isOpen]);

  if (!isOpen) return null;

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onCancel();
    }
  };

  const handleContentClick = (e) => {
    e.stopPropagation();
  };

  return (
    <div 
      className="overlay" 
      onClick={handleOverlayClick}
      role="dialog"
      aria-modal="true"
      aria-labelledby="modal-title"
    >
      <div 
        ref={modalRef}
        className="cancelRecurringMembershipModal" 
        onClick={handleContentClick}
        tabIndex="-1"
      >
        <button 
          className="cancelRecurringMembershipModalCloseButton" 
          onClick={onCancel}
          aria-label="Close modal"
        >
          ×
        </button>
        
        <h2 id="modal-title">Cancel Recurring Membership</h2>
        <p>
          Are you sure you want to cancel the automatic renewal for this membership?
          Your membership will remain active until the end of the current billing period.
        </p>
        
        <div className="modal-buttons">
          <button 
            className="cancelRecurringMembershipModalConfirmButton" 
            onClick={onConfirm}
            aria-label="Confirm cancellation of recurring membership"
          >
            Yes, Cancel Recurring
          </button>
          <button 
            className="cancelRecurringMembershipModalCancelButton" 
            onClick={onCancel}
            aria-label="Keep recurring membership"
          >
            No, Keep It
          </button>
        </div>
      </div>
    </div>
  );
}

export default CancelRecurringMembershipModal;
